import React from 'react';
import GridContainer from '../../../../Grid/GridContainer';
import GridItem from '../../../../Grid/GridItem';
import TransferServiceInfo from '../components/TransferServiceInfo';
import TransferMapSection from '../components/TransferMapSection';

const ModalCalendarTransferView = ({
  event,
  appointment,
  customer,
  state,
  formatTransferTypeRecive,
  formatDistance,
  translateStatus,
  formatPatientAddress,
  canAssignDriver,
  getStatus,
  handleToPDF,
  t,
  getTransferWayLabel,
  isOneWay
}: any) => {
  return (
    <div style={{ width: '100%' }}>
      <GridContainer>
        <GridItem xs={6} sm={6} md={6}>
          <TransferServiceInfo
            event={event}
            appointment={appointment}
            formatTransferTypeRecive={formatTransferTypeRecive}
            formatDistance={formatDistance}
            translateStatus={translateStatus}
            formatPatientAddress={formatPatientAddress}
            getTransferWayLabel={getTransferWayLabel}
            isOneWay={isOneWay}
            t={t}
          />
        </GridItem>
        <GridItem xs={6} sm={6} md={6}>
          <TransferMapSection
            customer={customer}
            event={event}
            state={state}
            getStatus={getStatus}
            handleToPDF={handleToPDF}
            canAssignDriver={canAssignDriver}
            t={t}
          />
        </GridItem>
      </GridContainer>
    </div>
  );
};

export default ModalCalendarTransferView; 